export enum SuggestionType {
    InitialSuggestion = "initial suggestion",
    FollowupSuggestion = "followup suggestion",
    GeneratedSuggestion = "generated suggestion",
}

export enum ValueChangeActionType {
    Select = "select value",
    Modify = "modify value",
    Remove = "remove value",
}
